(() => {
  document.querySelectorAll('.mds-model').forEach(root => {
    if (root.dataset.mdsReady) return;
    root.dataset.mdsReady = 'true';
    document.body.classList.add('mds-page-active');
    root.closest('.shopify-section')?.classList.add('mds-section-fullbleed');
    const date = root.querySelector('[data-mds-date]');
    const dateError = root.querySelector('[data-mds-date-error]');
    if (date) {
      date.min = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date());
      const validateDate = () => {
        let message = '';
        if (date.value && date.value < date.min) message = 'Choisissez aujourd’hui ou une date à venir.';
        else if (date.value && new Date(date.value + 'T12:00:00').getDay() === 0) message = 'La boutique est fermée le dimanche. Choisissez un jour du lundi au samedi.';
        date.setCustomValidity(message);
        date.classList.toggle('is-invalid', Boolean(message));
        if (message) date.setAttribute('aria-invalid','true'); else date.removeAttribute('aria-invalid');
        dateError.textContent = message;
        dateError.hidden = !message;
      };
      date.addEventListener('input', validateDate);
      date.addEventListener('change', validateDate);
      validateDate();
    }
    const sticky = root.querySelector('[data-mds-sticky]');
    const hero = root.querySelector('.mds-hero');
    if (sticky && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }).observe(hero);
      root.addEventListener('focusin', event => {
        sticky.classList.toggle('is-form-active', Boolean(event.target.closest('input, select, textarea')));
      });
      root.addEventListener('focusout', () => {
        requestAnimationFrame(() => sticky.classList.toggle('is-form-active', Boolean(root.contains(document.activeElement) && document.activeElement.matches('input, select, textarea'))));
      });
    }
    const status = root.querySelector('[data-momentum-form-success], .mds-form-errors');
    if (status) { status.scrollIntoView({block:'center'}); status.focus({preventScroll:true}); }
  });
})();
